/** Logique pure du bloc Carte info : quelle illustration afficher. */

/**
 * Ce qu'il faut peindre en haut (ou à gauche) de la carte.
 * - `icon`        : glyphe Tabler dans une pastille de couleur
 * - `image`       : photo (mode « Équipe »)
 * - `placeholder` : cadre pointillé — mode photo sans fichier, en édition
 *                   seulement (le site publié n'affiche rien)
 * - `null`        : rien
 */
export function resolveInfoCardIllustration({
  illustration = 'icon', icon = '', imageUrl = '', isEditing = false,
} = {}) {
  if (illustration === 'image') {
    if (imageUrl) return 'image';
    return isEditing ? 'placeholder' : null;
  }
  if (illustration === 'none') return null;
  return icon ? 'icon' : null;
}
